export default __webpack_public_path__ + "static/media/telephone.0bb09dac.svg";